/**
 * @file vacancies.ts
 * @path apps/website/src/data/vacancies.ts
 * @description
 */

// src/data/vacancies.ts

import { Vacancy } from "@sirbastians/types";



export const vacancies: Vacancy[] = [
  {
    id: "drv-01",
    title: "Professional Shuttle Driver",
    location: "Cape Town, Western Cape",
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Cape Town",
        addressRegion: "WC",
        postalCode: "8001",
        addressCountry: "ZA",
      },
    },
    type: "Full-time",
    employmentType: "FULL_TIME",
    description:
      "We are looking for an experienced and reliable shuttle driver to transport clients safely and comfortably. Must have a valid PrDP and excellent knowledge of the city.",
    datePosted: "2024-01-15",
    validThrough: "2024-12-31T23:59:59Z",
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "ZAR",
      value: {
        "@type": "QuantitativeValue",
        minValue: 18000,
        maxValue: 22000,
        unitText: "MONTH",
      },
    },
  },
  {
    id: "dsp-01",
    title: "Weekend Dispatch Coordinator",
    location: "Remote (Cape Town based)",
    type: "Part-time",
    employmentType: "PART_TIME",
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Cape Town",
        addressRegion: "WC",
        postalCode: "8001",
        addressCountry: "ZA",
      },
    },
    description:
      "Seeking a detail-oriented Dispatch Coordinator for weekend shifts. You will be responsible for managing bookings, assigning drivers, and ensuring smooth operations.",
    datePosted: "2024-01-20",
  },
  {
    id: "tour-guide-01",
    title: "Part-Time Seasonal Tour Guide",
    location: "Cape Town, Western Cape",
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Cape Town",
        addressRegion: "WC",
        postalCode: "8001",
        addressCountry: "ZA",
      },
    },
    type: "Part-time",
    employmentType: "PART_TIME",
    description:
      "Weekend dispatch to be tour guide, part time seasonal tour guide needed in all different languages.",
    datePosted: "2025-11-17",
  },
];
